var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveTransferTreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 24,
    height: 24,
    style: {
      borderColor: "rgba(0,0,0,0)",
      borderWidth: "bpx",
      borderStyle: "undefined"
    },
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 4.687l-11.313 11.313 11.313 11.313 11.313-11.313-11.313-11.313zM16.943 1.857l13.2 13.2c0.241 0.241 0.39 0.575 0.39 0.943s-0.149 0.701-0.39 0.943l-13.2 13.2c-0.241 0.241-0.575 0.39-0.943 0.39s-0.701-0.149-0.943-0.39l-13.2-13.2c-0.241-0.241-0.39-0.575-0.39-0.943s0.149-0.701 0.39-0.943l13.2-13.2c0.241-0.241 0.575-0.39 0.943-0.39s0.701 0.149 0.943 0.39v0zM17.333 13.333v-3.333l4.667 4.667-4.667 4.667v-3.333h-4v4h-2.667v-5.333c0-0.736 0.597-1.333 1.333-1.333v0h5.333z",
    fill: "rgba(204,204,204,1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTransferTreatment);
export default __webpack_public_path__ + "static/media/activeTransferTreatment.c7188826.svg";
export { ForwardRef as ReactComponent };